/**
 * @generated SignedSource<<bee93ba50a743621403dabc760667132>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GenderEnumType = "FEMALE" | "MALE" | "OTHER" | "%future added value";
export type PollFilter = {
  area?: string | null | undefined;
  gender?: GenderEnumType | null | undefined;
  isActive?: boolean | null | undefined;
  isMood?: boolean | null | undefined;
  search?: string | null | undefined;
  status?: string | null | undefined;
};
export type PollSelectFieldQuery$variables = {
  after?: string | null | undefined;
  count?: number | null | undefined;
  filters?: PollFilter | null | undefined;
};
export type PollSelectFieldQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PollSelectField_query">;
};
export type PollSelectFieldQuery = {
  response: PollSelectFieldQuery$data;
  variables: PollSelectFieldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v3 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v4 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v5 = [
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PollSelectFieldQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PollSelectField_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "PollSelectFieldQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "PollConnection",
        "kind": "LinkedField",
        "name": "polls",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfoExtended",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PollEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Poll",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "PollSelectField_polls",
        "kind": "LinkedHandle",
        "name": "polls"
      }
    ]
  },
  "params": {
    "cacheID": "3e0e2e2e2b2330eeeb744a3cf776a5f2",
    "id": null,
    "metadata": {},
    "name": "PollSelectFieldQuery",
    "operationKind": "query",
    "text": "query PollSelectFieldQuery(\n  $count: Int\n  $after: String\n  $filters: PollFilter\n) {\n  ...PollSelectField_query_1NP3V8\n}\n\nfragment PollSelectField_query_1NP3V8 on Query {\n  polls(first: $count, after: $after, filters: $filters) {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bbd7cac862ddb49fee9a6b6f971e9313";

export default node;
